<div class="visitor-leave-failed">
    <h1>{{'' | translate:
        ['tmc-yard.widgets.registration-terminal.visitor-leave-failed.description',
        translationService.language]}}</h1>

    <div class="error">
        <sc-icon iconClass="fa-circle-exclamation"></sc-icon>
    </div>

</div>
